var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.375 0.25C1.07663 0.25 0.790483 0.368527 0.579505 0.579505C0.368527 0.790483 0.25 1.07663 0.25 1.375V5.5C0.25 11.8037 5.61031 13.885 6.6477 14.2294C6.87613 14.3072 7.12387 14.3072 7.3523 14.2294C8.38969 13.885 13.75 11.8037 13.75 5.5V1.375C13.75 1.07663 13.6315 0.790484 13.4205 0.579505C13.2095 0.368526 12.9234 0.25 12.625 0.25H1.375ZM1.375 1.375L12.625 1.375V5.5C12.625 6.74373 12.3873 7.80013 12.0081 8.69408L7.32257 5.41418C7.12889 5.27861 6.8711 5.27861 6.67742 5.41418L1.9919 8.69404C1.6127 7.8001 1.375 6.74371 1.375 5.5L1.375 1.375ZM6.99999 6.56162L11.4847 9.70097C10.0433 12.0127 7.66896 12.9386 7 13.161C6.33103 12.9386 3.95665 12.0127 2.51526 9.70093L6.99999 6.56162Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.769795f4.svg";
export { ForwardRef as ReactComponent };